/**
 * Stap 6: klaar. De les is afgerond; per open vraag het antwoord van de
 * leerling en de feedback van Anna Maria. In een groepsles (stap 23): de
 * leerling las zijn deel, en gaat nu naar zijn groepje.
 */
import React from 'react';
import { Check } from 'lucide-react';
import { AnnaMariaZegt } from '../onderdelen/AnnaMaria';
import { Groepje } from '../onderdelen/Groepje';

export function Klaar({ naam, vragen, antwoorden, feedback, groepsles }) {
  if (groepsles) {
    return (
      <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
        <div className="card text-center" style={{ padding: '60px 40px' }}>
          <Check size={64} style={{ marginBottom: 24, color: 'var(--accent)' }} />
          <h1>Goed gedaan, {naam}!</h1>
          <p className="text-muted mt-16">Je hebt deel {groepsles.deel} gelezen. Ga nu naar je groepje en vertel wat er in jouw deel staat.</p>
          <Groepje groepsles={groepsles} style={{ maxWidth: 500, margin: '24px auto 0' }} />
        </div>
      </div>
    );
  }
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
      <div className="card text-center" style={{ padding: '60px 40px' }}>
        <Check size={64} style={{ marginBottom: 24, color: 'var(--accent)' }} />
        <h1>Goed gedaan, {naam}!</h1>
        <p className="text-muted mt-16">Je hebt de tekst en de toets afgerond.</p>

        {Object.keys(feedback).length > 0 && (
          <div className="mt-24" style={{ textAlign: 'left' }}>
            <h3>Feedback op je open antwoorden:</h3>
            {vragen.map((v, i) => (
              <div key={v.id} style={{ marginTop: 16, padding: 20, background: 'var(--vlak)', borderRadius: 12, borderLeft: '4px solid var(--accent)' }}>
                <p><strong>Vraag {i + 1}:</strong> {v.vraag}</p>
                <p style={{ color: 'var(--tekst-3)', marginTop: 8 }}><em>Jouw antwoord:</em> {antwoorden[v.id]}</p>
                <AnnaMariaZegt style={{ marginTop: 12 }}>{feedback[v.id]}</AnnaMariaZegt>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
